// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Restaumatic_Currencies from "../Restaumatic.Currencies/index.js";
import * as Restaumatic_Money_HrkToEur from "../Restaumatic.Money.HrkToEur/index.js";
var hrkDualPricesEnabledRef = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(/* #__PURE__ */ Effect_Ref["new"](false));
var isHrkDualPricesEnabled = /* #__PURE__ */ Effect_Ref.read(hrkDualPricesEnabledRef);
var setHrkDualPricesEnabled = function (b) {
    return Effect_Ref.write(b)(hrkDualPricesEnabledRef);
};
var withHrkDualPricesEnabled = function (b) {
    return function (computation) {
        return Effect_Unsafe.unsafePerformEffect(function __do() {
            var previous = isHrkDualPricesEnabled();
            var u = setHrkDualPricesEnabled(b)();
            var result = computation(u);
            setHrkDualPricesEnabled(previous)();
            return result;
        });
    };
};
var currencyOptions = function (v) {
    if (v instanceof Restaumatic_Currencies.PLN) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "z\u0142"
        };
    };
    if (v instanceof Restaumatic_Currencies.CZK) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: "",
            unit: "K\u010d"
        };
    };
    if (v instanceof Restaumatic_Currencies.GBP) {
        return {
            format: "%u%n",
            precision: 2,
            separator: ".",
            delimiter: ",",
            unit: "\xa3"
        };
    };
    if (v instanceof Restaumatic_Currencies.USD) {
        return {
            format: "%u%n",
            precision: 2,
            separator: ".",
            delimiter: "",
            unit: "$"
        };
    };
    if (v instanceof Restaumatic_Currencies.EUR) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: "",
            unit: "EUR"
        };
    };
    if (v instanceof Restaumatic_Currencies.RUB) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "\u0440\u0443\u0431."
        };
    };
    if (v instanceof Restaumatic_Currencies.RON) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "RON"
        };
    };
    if (v instanceof Restaumatic_Currencies.HRK) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "kn"
        };
    };
    if (v instanceof Restaumatic_Currencies.BRL) {
        return {
            format: "%u%n",
            precision: 2,
            separator: ".",
            delimiter: "",
            unit: "R$"
        };
    };
    throw new Error("Failed pattern match at Restaumatic.I18n.Currency (line 42, column 3 - line 51, column 87): " + [ v.constructor.name ]);
};
var currencyUnit = function ($6) {
    return (function (v) {
        return v.unit;
    })(currencyOptions($6));
};
var formatCurrencySimple = function (currency) {
    return function (value) {
        return $foreign["_formatCurrency"](currencyOptions(currency), Data_Money_Rounded.toNumber(value));
    };
};
var formatCurrency = function (v) {
    return function (value) {
        if (v instanceof Restaumatic_Currencies.HRK && Effect_Unsafe.unsafePerformEffect(isHrkDualPricesEnabled)) {
            return formatCurrencySimple(Restaumatic_Currencies.HRK.value)(value) + (" (" + (formatCurrencySimple(Restaumatic_Currencies.EUR.value)(Restaumatic_Money_HrkToEur.hrkToEur(value)) + ")"));
        };
        return formatCurrencySimple(v)(value);
    };
};
export {
    formatCurrency,
    currencyUnit,
    isHrkDualPricesEnabled,
    setHrkDualPricesEnabled,
    withHrkDualPricesEnabled
};
//# sourceMappingURL=index.js.map
